/**
 * @generated SignedSource<<f7f0ebfbe4dedfab2bead3c7ef77b3df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ModalStepOutlet_CancelBooking_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CancelBooking_Booking">;
  readonly " $fragmentType": "ModalStepOutlet_CancelBooking_Booking";
};
export type ModalStepOutlet_CancelBooking_Booking$key = {
  readonly " $data"?: ModalStepOutlet_CancelBooking_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ModalStepOutlet_CancelBooking_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ModalStepOutlet_CancelBooking_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelBooking_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "bb15d7ba49160eaf7ed4947600f67270";

export default node;
